import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as uuid from 'uuid';

export interface FileInputData {
  value: string | number
  valid: boolean
}

@Component({
  selector: 'app-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss']
})
export class FileInputComponent {

  id = 'file-' + uuid.v4();

  // Inputs
  @Input() label: string;
  @Input() caption: string;
  @Input() disabled: boolean;
  @Input() multiple: boolean;
  @Input() required: boolean;
  @Input() allowExt: string[];

  //Outputs
  @Output() changed: EventEmitter<FileInputData> = new EventEmitter();

}
